import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";
import {PATH_STATISTIC} from "@constants/navigate";

export const BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC: IBreadcrumbItem[] = [
    {
        label: 'base.statistic',
        path:PATH_STATISTIC
    },
    {
        label: 'deviceOperationStatistic.name',
    },
]

export const BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES: IBreadcrumbItem[] = [
    {
        label: 'base.statistic',
        path:PATH_STATISTIC
    },
    {
        label: 'deviceOperationStatistic.byDevices',
    },
]